import React from 'react';
import { buildResponsiveCSS } from '../../../utils/css.mjs';
import styled from 'styled-components';

const StyledContainer = styled.div `
  ${props => { var _a; return buildResponsiveCSS('padding', (_a = props.padding) !== null && _a !== void 0 ? _a : (props.fullWidth ? '0' : '0 1rem')); }};
  ${props => { var _a; return buildResponsiveCSS('margin', (_a = props.margin) !== null && _a !== void 0 ? _a : 'auto'); }};
  ${props => { var _a; return buildResponsiveCSS('position', (_a = props.position) !== null && _a !== void 0 ? _a : 'none'); }};
  ${props => { var _a; return buildResponsiveCSS('top', (_a = props.top) !== null && _a !== void 0 ? _a : 'auto'); }};
  ${props => { var _a; return buildResponsiveCSS('bottom', (_a = props.bottom) !== null && _a !== void 0 ? _a : 'auto'); }};
  ${props => { var _a; return buildResponsiveCSS('left', (_a = props.left) !== null && _a !== void 0 ? _a : 'auto'); }};
  ${props => { var _a; return buildResponsiveCSS('right', (_a = props.right) !== null && _a !== void 0 ? _a : 'auto'); }};
  ${props => { var _a; return buildResponsiveCSS('width', (_a = props.width) !== null && _a !== void 0 ? _a : 'auto'); }};
  ${props => { var _a; return buildResponsiveCSS('height', (_a = props.height) !== null && _a !== void 0 ? _a : 'auto'); }};

  background-color: ${props => { var _a; return (_a = props.backgroundColor) !== null && _a !== void 0 ? _a : 'transparent'; }};
  max-width: ${props => (props.fullWidth ? '100%' : props.theme.breakpoints.xxl)};

  @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
    ${props => { var _a; return buildResponsiveCSS('padding', (_a = props.padding) !== null && _a !== void 0 ? _a : (props.fullWidth ? '0' : '0 3.75rem')); }};
  }
`;
const Container = ({ className, children, fullWidth, backgroundColor, padding, margin, position, top, bottom, left, right, width, height }) => {
    return (React.createElement(StyledContainer, { className: className, fullWidth: fullWidth, backgroundColor: backgroundColor, padding: padding, margin: margin, position: position, top: top, bottom: bottom, left: left, right: right, width: width, height: height }, children));
};

export { Container as default };
//# sourceMappingURL=Container.mjs.map
